<template>
  <div class="aboutUs">
    <!-- title -->
    <div class="aboutUs-title">关于我们</div>
    <hr />
    <!-- 内容区 -->
    <div class="aboutUs-content">
      <!-- 公司简介 -->
      <div class="content-title">{{ companyProfile.title }}</div>
      <div class="content-main">{{ companyProfile.content }}</div>
      <!-- 核心业务 -->
      <div class="content-title">{{ business.title }}</div>
      <div class="content-main">
        <ol>
          <li v-for="(item, index) in business.introduce" :key="index">
            <p class="main-title">{{ item.title }}</p>
            <p class="main-content">{{ item.content }}</p>
          </li>
        </ol>
      </div>
      <!-- 企业愿景与使命 -->
      <div class="content-title">{{ corporateVision.title }}</div>
      <div class="content-main">{{ corporateVision.content }}</div>
    </div>
    <!-- 邀约 -->
    <div class="content-title">{{ invitation.title }}</div>
    <div class="content-main">
      <span class="description">{{invitation.description}}</span>
      <ul class="main-ul">
        <li v-for="(item,index) in invitation.introduce" :key="index">{{item.content}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 公司简介
      companyProfile: {
        title: "公司简介",
        content:
          "花椒视觉，作为积极推动美业数字化进程的倡导者与领路人，致力于为全球美业人士和爱好者提供一个全面且先进的分享、学习与沟通的综合性平台。公司始终坚持以科技赋能美业发展的核心理念，通过多元化的产品矩阵和服务体系，有力地撬动了美业领域向更专业、更高效、更智能的方向发展，为美业生态的繁荣进步提供源源不断的动力引擎。",
      },
      // 核心业务
      business: {
        title: "核心业务",
        introduce: [
          {
            title: "在线课堂",
            content:
              "花椒视觉倾力打造了一系列专业在线美业课程，涵盖半永久、美甲、美睫等多个细分领域。这些课程由业内资深专家及知名讲师亲授，采用高清视频教学与互动答疑相结合的方式，让学员无论身处何地都能便捷地获取最新的行业知识和技术技巧，实现自我提升与职业技能的持续更新。",
          },
          {
            title: "线下课堂",
            content:
              "除了线上教育资源，花椒视觉还组织各类线下研讨会、工作坊以及大师级研习班，为学员提供实践操作指导和面对面交流的机会，将理论知识与实际操作紧密结合，进一步提升用户在美业领域的实战能力。",
          },
          {
            title: "美业AI工具",
            content:
              "花椒视觉敏锐捕捉到AI技术在美业的应用潜力，自主研发了一系列基于人工智能技术的美业辅助工具。例如：智能色彩搭配、创意方案撰写工具等，帮助美业人精准匹配客户需求，提供个性化服务方案，并优化运营决策过程，引领美业进入智能化时代。",
          },
        ],
      },
      // 企业愿景与使命
      corporateVision: {
        title: "企业愿景与使命",
        content:
          "花椒视觉坚持以用户需求为导向，利用前沿科技打破传统美业教育与服务的边界，构建起线上线下一体化的学习与成长生态系统，旨在培养更多具备高技术水平的专业人才，同时也助力美业企业提升品牌影响力与核心竞争力，共同塑造美业行业的未来新貌。花椒视觉不仅是一个连接美业人的桥梁，更是推动整个行业走向数字化、智能化转型的重要引擎，通过其丰富多样的产品组合，为美业的无限可能提供技术支持。",
      },
      // 邀约
      invitation: {
        title: "邀约",
        description: '诚邀您一起参与打造美业生态：',
        introduce: [
          {
            content: "分享你的优秀作品，花椒为你接力传播",
          },
          {
            content: "引荐你的身边人才，花椒让他绽放光彩",
          },
          {
            content: "说出你的疑难杂症，花椒替你排难解忧",
          },
        ],
      },
    };
  },
};
</script>

<style>
.aboutUs {
  width: 90%;
  height: 100%;
  margin: 0 auto;
}
.aboutUs-title {
  width: 100%;
  height: 50px;
  margin-top: 20px;
  font-size: 35px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.aboutUs-content {
  width: 100%;
  height: 100%;
  text-indent: 2em;
}
.content-title {
  margin: 35px 0 20px 0;
  width: 100%;
  height: 30px;
  font-size: 30px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-main {
  padding: 20px;
  font-size: 20px;
  line-height: 50px;
}
.main-title {
  text-indent: 0em;
  font-size: 24px;
  font-weight: 600;
}
.description {
  font-size: 30px;
  font-weight: 600;
}
</style>
